import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Settings from './pages/Settings';
import NFeDocs from './pages/NFeDocs';
import CTeDocs from './pages/CTeDocs';
import MDFeDocs from './pages/MDFeDocs';
import Inutilizacao from './pages/Inutilizacao';
import Xml from './pages/Download';
import EmailLogs from './pages/EmailLogs';
import NotFound from './pages/NotFound';

const Routers: React.FC = () => {
  return (
    <Routes>
      <Route path="/settings" element={<Settings />} />
      <Route path="/settings/:token" element={<Settings />} />
      <Route path="/nfe" element={<NFeDocs />} />
      <Route path="/nfe/:token" element={<NFeDocs />} />
      <Route path="/cte" element={<CTeDocs />} />
      <Route path="/cte/:token" element={<CTeDocs />} />
      <Route path="/mdfe" element={<MDFeDocs />} />
      <Route path="/mdfe/:token" element={<MDFeDocs />} />
      <Route path="/inutilizacao" element={<Inutilizacao />} />
      <Route path="/inutilizacao/:token" element={<Inutilizacao />} />
      <Route path="/xml" element={<Xml />} />
      <Route path="/xml/:token" element={<Xml />} />
      <Route path="/email-logs" element={<EmailLogs />} />
      <Route path="/email-logs/:token" element={<EmailLogs />} />
      {/* <Route path="/" element={<Home />} /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
